import { z } from "zod";

export const memberRoleSchema = z.enum(["owner", "admin", "editor", "staff"]);
export type MemberRole = z.infer<typeof memberRoleSchema>;

export type Permission =
  | "org:manage"
  | "billing:manage"
  | "members:manage"
  | "restaurant:manage"
  | "menu:edit"
  | "menu:publish"
  | "translation:edit"
  | "import:run"
  | "analytics:view"
  | "orders:manage"
  | "orders:view"
  | "tables:manage"
  | "kitchen:manage";

const ROLE_PERMISSIONS: Record<MemberRole, Permission[]> = {
  owner: [
    "org:manage", "billing:manage", "members:manage", "restaurant:manage", "menu:edit", "menu:publish",
    "translation:edit", "import:run", "analytics:view", "orders:manage", "orders:view", "tables:manage", "kitchen:manage",
  ],
  admin: [
    "members:manage", "restaurant:manage", "menu:edit", "menu:publish", "translation:edit", "import:run",
    "analytics:view", "orders:manage", "orders:view", "tables:manage", "kitchen:manage",
  ],
  editor: ["menu:edit", "menu:publish", "translation:edit", "import:run", "analytics:view", "orders:view"],
  staff: ["orders:manage", "orders:view"],
};

export function roleHasPermission(role: MemberRole, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].includes(permission);
}

export function permissionsForRole(role: MemberRole): Permission[] {
  return [...ROLE_PERMISSIONS[role]];
}

/** Roles a member with `actor` role may assign. Only owners may create admins; nobody assigns owner via invite. */
export function assignableRoles(actor: MemberRole): MemberRole[] {
  if (actor === "owner") return ["admin", "editor", "staff"];
  if (actor === "admin") return ["editor", "staff"];
  return [];
}
